import * as React from 'react'

import { Hr } from '~ui/components/layout/Hr'

type TProps = NoChildren & {
  contrast?: PropsOf<typeof Hr>['contrast']
}

export const CART_CONTENT_DIVIDER_THICKNESS = 1

/**
 * Renders a divider between cart items.
 */
export const CartContentDivider: React.FC<TProps> = ({ contrast = `low` }) => {
  return <Hr thickness={`${CART_CONTENT_DIVIDER_THICKNESS}px`} contrast={contrast} />
}
